import { useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { DocumentContext } from '../../../context/documentContext';
import { PdfBufferViewer, PdfBufferViewerHandle } from './pdfBufferViewer';
import { UserContext } from '../../../context/authContext';
import { useSearchParams } from 'react-router-dom';
import { documentTableItem } from '../../../lib/models/interfaces';
import PolicyDocumentViewer from './policyDocumentViewer';
import {
  PdfViewerAnnotationSelection,
  PdfViewerTextSelectionMatch
} from './searchablePdfViewer';
import { PdfFallbackPageItemsByPage } from './search/pdfFallbackSearch';

export const PolicyLayoutContainer = () => {
  // context hooks
  const { setCurrentDocId, allDocuments } = useContext(DocumentContext);
  const { auth, token } = useContext(UserContext);
  const viewerRef = useRef<PdfBufferViewerHandle | null>(null);
  const [queryParameters] = useSearchParams();

  //state

  const [currentDocuments, setCurrentDocument] = useState<documentTableItem[]>(
    []
  );
  const [documentBuffer, setDocumentBuffer] = useState<ArrayBuffer | null>(
    null
  );
  const [fallBackPageItems, setFallBackPageItems] =
    useState<PdfFallbackPageItemsByPage>({});
  const [selectedAnnotationReference, setSelectedAnnotationReference] =
    useState<PdfViewerAnnotationSelection | null>(null);
  const [currentPdfPage, setCurrentPdfPage] = useState<number | null>(null);
  const [manualBenchmarkSelection, setManualBenchmarkSelection] = useState<
    (PdfViewerTextSelectionMatch & { selectionKey: number }) | null
  >(null);
  const getRelevantDoc = () => {
    const id = queryParameters.get('documentId');
    const thisDoc = allDocuments.filter((ele) => ele._id === id);
    if (thisDoc) {
      setCurrentDocument(thisDoc);
    }
    // setDocumentIds(ids);
  };
  const fetchPDFBuffer = async (url: string): Promise<ArrayBuffer> => {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch PDF: ${response.status}`);
    }

    return response.arrayBuffer();
  };

  const getImageFromS3 = async () => {
    if (!token) return;
    try {
      const docId = queryParameters.get('documentId');
      if (!docId) return;

      console.log('getting s3 file for', docId);
      const res = await axios.post(
        `${process.env.REACT_APP_KORU_API}/get-presigned-url?type=getContractPDF`,
        { documentId: docId },
        auth
      );
      const url = res.data.url;
      const buffer = await fetchPDFBuffer(url);
      setDocumentBuffer(buffer);
    } catch (e) {
      console.log('Error from get Image', e);
    }
  };

  useEffect(() => {
    if (queryParameters.get('documentId')) {
      setCurrentDocId(queryParameters.get('documentId')!);
    }
    getImageFromS3();
    getRelevantDoc();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="grid h-[90vh] w-screen grid-cols-2 overflow-hidden bg-white">
      <section
        id="left"
        className="h-full max-h-[90vh] min-h-0 min-w-0 border-r border-slate-200"
      >
        <PdfBufferViewer
          buffer={documentBuffer}
          fileName={currentDocuments[0]?.documentFileName ?? 'document.pdf'}
          ref={viewerRef}
          fallbackPdfPageItems={fallBackPageItems}
          onCurrentPageChange={setCurrentPdfPage}
          onAnnotationReferenceSelect={setSelectedAnnotationReference}
          onTextSelectionMatch={(selection) => {
            console.log('selection layout viewer', selection);
            setManualBenchmarkSelection((previousValue) => ({
              ...selection,
              selectionKey: (previousValue?.selectionKey ?? 0) + 1
            }));
          }}
        />
      </section>
      <section
        id="right"
        className="h-full min-h-0 max-h-[90vh]  min-w-0 overflow-hidden"
      >
        <PolicyDocumentViewer
          currentPdfPage={currentPdfPage}
          manualBenchmarkSelection={manualBenchmarkSelection}
          selectedAnnotationReference={selectedAnnotationReference}
          viewerRef={viewerRef}
          fallbackPageItems={fallBackPageItems}
          setFallbackPageItems={setFallBackPageItems}
        />
      </section>
    </div>
  );
};
